import { Component } from 'react';
import { twMerge } from 'tailwind-merge';
import Select from 'react-scale/corp/components/UI/Select';

interface SelectOptionsProps {
  value?: { label: string; value: string } | { label: string; value: string }[];
  options: { label: string; value: string }[];
  onChange?: (e: any) => void;
  placeholder: string;
  multi?: boolean;
  className?: string;
}

export default class SelectOptions extends Component<SelectOptionsProps> {
  static defaultProps = {
    placeholder: 'Select an option',
  };

  render() {
    const { className, ...restProps } = this.props;
    const mergedClassName = twMerge(className);

    return (
      <Select
        {...restProps}
        className={mergedClassName}
        options={this.props.options}
        ignoreCase={true}
        closeOnSelect={false}
      />
    );
  }
}
